import { useEffect } from 'react';

import { useSessionContext } from '@/auth/useSessionContext';
import { levelForSales } from '@/utils/constants';

// A aba do painel mostra o cacto do nível do produtor, o mesmo ícone que o app usa por nível
// (CKTMB-515). O nível é da pessoa, não do negócio selecionado (CBK-603), como a placa do menu.
// Fora do painel volta o favicon da marca que o index.html declara: login, checkout e área do
// aluno não são do produtor. O apple-touch-icon fica, porque é o favorito da tela inicial.
export default function LevelFavicon() {
  const { user } = useSessionContext();
  const code = user ? levelForSales(user.totalSales || 0).code : null;

  useEffect(() => {
    if (!code) return undefined;

    const links = Array.from(document.querySelectorAll('link[rel="icon"]'));
    const originals = links.map((link) => link.getAttribute('href'));

    links.forEach((link) => link.setAttribute('href', `/favicon/levels/${code}.png`));

    return () => links.forEach((link, index) => link.setAttribute('href', originals[index]));
  }, [code]);

  return null;
}
